var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineUpSmooth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3C4.55228 3 5 3.44772 5 4V17C5 18.1046 5.89543 19 7 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H7C4.79086 21 3 19.2091 3 17V4C3 3.44772 3.44772 3 4 3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3163 3.05131C20.8402 3.22596 21.1234 3.79228 20.9487 4.31622L18.972 10.2462C18.2668 12.3619 15.5816 12.9958 14.0047 11.4189L12.5812 9.99535C12.0555 9.4697 11.1605 9.68099 10.9254 10.3862L8.94871 16.3162C8.77406 16.8402 8.20774 17.1233 7.6838 16.9487C7.15986 16.774 6.8767 16.2077 7.05134 15.6838L9.02801 9.75377C9.73324 7.63807 12.4184 7.00418 13.9954 8.58114L15.4189 10.0046C15.9445 10.5303 16.8396 10.319 17.0747 9.61377L19.0513 3.68377C19.226 3.15983 19.7923 2.87667 20.3163 3.05131Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineUpSmooth);
export default __webpack_public_path__ + "static/media/line-up-smooth.9567069c78a58214aaaf451e1762c572.svg";
export { ForwardRef as ReactComponent };